
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.5 2.5h-.833V.833A.834.834 0 0015.833 0H15a.834.834 0 00-.833.833V2.5H5.833V.833A.834.834 0 005 0h-.833a.834.834 0 00-.834.833V2.5H2.5A2.503 2.503 0 000 5v12.5C0 18.878 1.122 20 2.5 20h15c1.378 0 2.5-1.122 2.5-2.5V5c0-1.378-1.122-2.5-2.5-2.5zm.833 15c0 .46-.374.833-.833.833h-15a.835.835 0 01-.833-.833V8.367h16.666V17.5z"}})])
          )
        }
      }
    